import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { formatISO } from 'date-fns';
import { rem } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { formatAmount, formatDateForItem, formatETADateForItem } from 'utils/formatting';
import { isWeb } from '../../../constants';
import { getSign } from '../utils';
import AutosaveActivityCardForPot from './AutosaveActivityCardForPot';
import PotActivityView from './PotActivity';
import UpcomingAutosavePaymentCard from './UpcomingAutosavePaymentCard';
const PotsActivityRow = ({ item, pot, hideSpaceUserAvatar }) => {
    const styles = useStyles(styleSet);
    const borderStyles = useMemo(() => [item.isFirstInSection && styles.firstItem, item.isLastInSection && styles.lastItem], [item.isFirstInSection, styles.firstItem, styles.lastItem, item.isLastInSection]);
    if ('sectionTitle' in item) {
        return (<SectionHeader horizontalMargins style={styles.sectionHeader}>
        {item.sectionTitle}
      </SectionHeader>);
    }
    if ('skipped' in item) {
        return <UpcomingAutosavePaymentCard upcomingPayment={item}/>;
    }
    if (item.type === 'AUTO_SAVE') {
        return (<View style={[styles.item, borderStyles]}>
        <AutosaveActivityCardForPot activity={item} btnStyles={borderStyles} pot={pot}/>
      </View>);
    }
    const formattedDate = (() => {
        if (item.status === 'PENDING') {
            if (item.depositEta) {
                return formatETADateForItem(formatISO(item.depositEta));
            }
            if (item.eta) {
                return formatETADateForItem(formatISO(item.eta));
            }
        }
        else if (item.timestamp) {
            return formatDateForItem(formatISO(item.timestamp));
        }
        return '';
    })();
    return (<View style={[styles.item, borderStyles]}>
      <PotActivityView pot={pot} eta={item.eta} type={item.type} title={item.title} emoji={item.emoji} status={item.status} amount={item.amount} timestamp={item.timestamp} depositEta={item.depositEta} formattedDate={formattedDate} productId={item.potProductId} bankName={item.potPartnerBankName} depositDetails={item.depositDetails} isBankTransfer={item.isBankTransfer} hideSpaceUserAvatar={hideSpaceUserAvatar} forceShowPositiveAmount={item.amount.value > 0} formattedAmount={`${getSign(item)}${formatAmount(item.amount.value, item.amount.currency, 2)}`}/>
    </View>);
};
export default memo(PotsActivityRow);
const styleSet = createStyleSheets((colors) => ({
    sectionHeader: {
        paddingTop: rem(24),
        paddingBottom: rem(16),
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
        ...(isWeb && { paddingTop: rem(8) }),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
        ...(isWeb && { paddingBottom: rem(8) }),
    },
    item: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        // On web the card is padded by 8 and each row by 8, so the hover highlight sits inside the card
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
}));
